import React from "react";

const AppStreamState = ({ appstream_state }) => (
    <>
        {appstream_state == 'ACTIVE' &&
            <small className="text-success">Active</small>}
        {appstream_state == 'RESERVED' &&
            <small className="text-success">Reserved</small>}
        {appstream_state == 'PENDING' &&
            <small className="text-info">Pending</small>}
        {appstream_state == 'EXPIRED' &&
            <small className="text-danger">Expired</small>}
    </>
);

export default AppStreamState;